module.exports = __webpack_public_path__ + "img/32.4b17d740.jpg";